import { render, staticRenderFns } from "./Extrato.vue?vue&type=template&id=263a04d5"
import script from "./Extrato.vue?vue&type=script&lang=ts"
export * from "./Extrato.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports